import React, { createContext, useCallback, useEffect, useState } from 'react';

import { MlifeActivationRequest } from '../../api/fetch/mlife-activation';
import { useEvent } from '../../utils/analytics/useEvent';

export type Context = {
  step: 'activate' | 'verify' | 'accountSetup';
  setStep: React.Dispatch<React.SetStateAction<'activate' | 'verify' | 'accountSetup'>>;
  activationRequest?: MlifeActivationRequest;
  setActivationRequest: React.Dispatch<React.SetStateAction<MlifeActivationRequest | undefined>>;
  resetActivationForm: () => void;
};

export const MlifeActivationContext = createContext<Context>({} as Context);

export const MlifeActivationContextProvider = ({ children }: { children?: React.ReactNode }) => {
  const trackEvent = useEvent();
  const [step, setStep] = useState<'activate' | 'verify' | 'accountSetup'>('activate');
  const [activationRequest, setActivationRequest] = useState<MlifeActivationRequest>();

  const resetActivationForm = useCallback(() => {
    setStep('activate');
  }, []);

  useEffect(() => {
    switch (step) {
      case 'activate':
        trackEvent('identity – mlife activation - start', 'start mlife activation process', 'mlifeactivatestart');
        break;
      case 'verify':
        trackEvent('identity – verify your email - start', 'start verify your email process', 'verifyemailstart');
        break;
    }
  }, [trackEvent, step]);

  return (
    <MlifeActivationContext.Provider
      value={{
        step,
        setStep,
        activationRequest,
        setActivationRequest,
        resetActivationForm,
      }}
    >
      {children}
    </MlifeActivationContext.Provider>
  );
};
